import { render } from "./CriticalFutureYearsPage.vue?vue&type=template&id=f4fea8fe"
import script from "./CriticalFutureYearsPage.vue?vue&type=script&lang=js"
export * from "./CriticalFutureYearsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__